import { render, staticRenderFns } from "./ZapZone.vue?vue&type=template&id=18616747&"
import script from "./ZapZone.vue?vue&type=script&lang=js&"
export * from "./ZapZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports